module.exports = __webpack_public_path__ + "img/mobile-index-technology-service.png.ef349629.png";